export default __webpack_public_path__ + "static/media/textMsg.8a442f78.jpg";